import React, { Component } from "react";
import {
  Container,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
} from "@material-ui/core";
import { Card } from "react-bootstrap";
import FacilityDescription from "./FacilityDescription";
import BreadCrumbOwn from "../Essentials/BreadCrumbOwn";

const list = [
  {
    title: "Library",
    link: "/facility/library",
  },
  {
    title: "Student Support",
    link: "/facility/studentsupport",
  },
  // {
  //   title: "Boys Hostel",
  //   link: "/facility/boyshostel",
  // },
  // {
  //   title: "Girls Hostel",
  //   link: "/facility/girlshostel",
  // },
  {
    title: "CIF",
    link: "/facility/cif",
  },
  {
    title: "Canteen",
    link: "/facility/canteen",
  },
  {
    title: "CGPC",
    link: "/facility/cgpc",
  },
  {
    title: "Career Guidance and Placement Cell",
    link: "/facility/Career_Placement_Cell"
  }
];

class PanduFacility extends Component {
  state = {
    link: "",
  };
  componentDidMount() {
    let link = this.props.match.params.link;
    this.setState({
      link: link,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.link != this.props.match.params.link) {
      let link = this.props.match.params.link;
      this.setState({
        link: link,
      });
    }
  }

  render() {
    return (
      <div>
        <BreadCrumbOwn title="Home > Facilities" />
        <Container className="mb-4" style={{minHeight: '500px'}}>
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              sm={12}
              md={3}
              lg={3}
              style={{ paddingTop: "5em" }}
            >
              <Card
                style={{
                  boxShadow: "none",
                  position: "stickey !important",
                  top: "0 !important",
                }}
              >
                <div
                  style={{
                    boxShadow: "none",
                    position: "stickey",
                    top: "0",
                  }}
                >
                  <List component="nav">
                    {list.map((el, index) => (
                      <ListItem
                        button
                        style={{
                          border: "1px solid #0002",
                          marginBottom: "2px",
                          backgroundColor: el.link === `/facility/${this.state.link}` ? '#F5EB3D' :'#f9f9f9'
                        }}
                        key={index}
                        onClick={() => this.props.history.push(el.link)}
                      >
                        <div
                          style={{
                            fontSize: "1.2em",
                            fontWeight: "700",
                            padding: "0",
                          }}
                        >
                          {el.title}
                        </div>
                      </ListItem>
                    ))}
                  </List>
                </div>
              </Card>
            </Grid>

            <Grid item xs={12} sm={12} md={9} lg={9}>
              <FacilityDescription type={this.state.link} />
            </Grid>
            
          </Grid>
        </Container>
      </div>
    );
  }
}

export default PanduFacility;
